import React from "react";
import axios from "axios";
import { apiCall_domain } from "../api";
import Header from "../header";
import { Rating } from "react-simple-star-rating";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import TabsCom from "./Tabs";

class categoryDetails extends React.Component {
  state = {
    mechanicsInfgo: [],
    loading: true,
    VendorHeader: true,
  };
  componentDidMount() {
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    const Data = {
      mechanic_id: localStorage.getItem("mechanic_id"),
    };
    axios
      .post(`${apiCall_domain}/customer/mechanics/info`, Data, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ mechanicsInfgo: res.data.data, loading: false });
      });
  }
  Reservation = () => {
    localStorage.setItem("garage_id", this.state.mechanicsInfgo.id);
    localStorage.setItem(
      "mechanic_Days",
      JSON.stringify(this.state.mechanicsInfgo.days),
    );
    this.props.history.push({
      pathname: "/multiVendor/categoryDetails/Reservation",
    });
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={`${this.state.mechanicsInfgo.name}`}
              VendorHeader={this.state.VendorHeader}
            />
            <div className="mechanicsDetails">
              <div className="mechanicsImg">
                <img src={this.state.mechanicsInfgo.image} alt="pic" />
              </div>
              <div className="mechanicsMoreDetails">
                <div className="kacharNameLogo">
                  <div className="name">{this.state.mechanicsInfgo.name}</div>
                  <img src="/public/assets/icons/kachar01.svg" alt="pic" />
                </div>
                <div className="ratingCategory">
                  <Rating
                    ratingValue={this.state.mechanicsInfgo.rate * 20}
                    readonly={true}
                  />
                </div>
                <div className="Servicestype">
                  <img src="/public/assets/icons/repair222.svg" alt="pic" />
                  {/* <div className="type"> */}
                  <span className="ServicestypeQ"> نحوه خدمت رسانی : </span>
                  <span className="ServicestypeA">{`${
                    this.state.mechanicsInfgo.type === "both"
                      ? "خدمات سیار و ثابت"
                      : this.state.mechanicsInfgo.type === "static"
                        ? "خدمات ثابت"
                        : this.state.mechanicsInfgo.type === "dynamic"
                          ? "خدمات سیار"
                          : ""
                  }`}</span>
                  {/* </div> */}
                </div>
                <div className="Servicestype">
                  <img src="/public/assets/icons/Vector.svg" alt="pic" />
                  <span className="ServicestypeQ"> نوع خدمات : </span>
                  <span className="ServicestypeA">
                    {this.state.mechanicsInfgo.service !== null &&
                      this.state.mechanicsInfgo.service.title}
                  </span>
                </div>
                <div className="Servicestype">
                  <img src="/public/assets/icons/serviceAv.svg" alt="pic" />
                  <span className="ServicestypeQ"> خدمات قابل ارائه : </span>
                  <span className="ServicestypeA">
                    {this.state.mechanicsInfgo.service !== null &&
                      this.state.mechanicsInfgo.services.map(
                        (Item) => " " + Item.title + " " + " _ ",
                      )}
                  </span>
                </div>
              </div>
              <div className="Reservation">
                <button onClick={() => this.Reservation()}>رزرو سرویس</button>
              </div>
              <TabsCom
                mechanicsInfgo={this.state.mechanicsInfgo}
                props={this.props}
              />
            </div>
          </>
        )}
      </>
    );
  }
}
export default categoryDetails;
